import React, { useState } from "react";

const MediaInfluencerApply = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    discordTag: "",
    platform: "",
    channelLink: "",
    followers: "",
    contentType: "",
    whyJoin: "",
  });

  const [status, setStatus] = useState({ message: "", type: "" });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const webhookURL =
      "https://discord.com/api/webhooks/1375123454981963816/TtjI06H_P9cYpvFY7BOaDdtZkddT9WQIKA2NFpam8CHE-pPlwlRtcWzLXYH0tVLJvXuv";

    const embed = {
      embeds: [
        {
          title: "🎥 New Media/Influencer Application",
          color: 0x5b8def,
          fields: [
            { name: "Full Name", value: formData.fullName || "N/A" },
            { name: "Discord Tag", value: formData.discordTag || "N/A" },
            { name: "Platform", value: formData.platform || "N/A" },
            { name: "Channel/Profile Link", value: formData.channelLink || "N/A" },
            { name: "Followers/Subscribers", value: formData.followers || "N/A" },
            { name: "Content Type", value: formData.contentType || "N/A" },
            { name: "Reason to Join", value: formData.whyJoin || "N/A" },
          ],
          footer: {
            text: "RixxyMC Creator Application",
          },
          timestamp: new Date().toISOString(),
        },
      ],
    };

    try {
      const res = await fetch(webhookURL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(embed),
      });

      if (!res.ok) throw new Error("Webhook submission failed");

      setStatus({ message: "✅ Application submitted successfully!", type: "success" });
      setFormData({
        fullName: "",
        discordTag: "",
        platform: "",
        channelLink: "",
        followers: "",
        contentType: "",
        whyJoin: "",
      });
    } catch (err) {
      setStatus({ message: "❌ Submission failed. Please try again later.", type: "error" });
    }
  };

  return (
    <div className="container">
      <h2>Media/Influencer Application</h2>
      <p>Apply as a YouTuber, TikToker, or streamer to partner with RixxyMC.</p>

      {status.message && (
        <div style={{ marginTop: "1rem", color: status.type === "success" ? "green" : "red" }}>
          {status.message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <label htmlFor="fullName">Full Name:</label>
        <input
          type="text"
          id="fullName"
          value={formData.fullName}
          onChange={handleChange}
          placeholder="Your full name"
          required
        />

        <label htmlFor="discordTag">Discord Tag (e.g. user#1234):</label>
        <input
          type="text"
          id="discordTag"
          value={formData.discordTag}
          onChange={handleChange}
          placeholder="Your Discord tag"
          required
        />

        <label htmlFor="platform">Primary Platform:</label>
        <input
          type="text"
          id="platform"
          value={formData.platform}
          onChange={handleChange}
          placeholder="YouTube, TikTok, Twitch, etc."
          required
        />

        <label htmlFor="channelLink">Channel or Profile Link:</label>
        <input
          type="url"
          id="channelLink"
          value={formData.channelLink}
          onChange={handleChange}
          placeholder="Link to your channel/profile"
          required
        />

        <label htmlFor="followers">Number of Followers/Subscribers:</label>
        <input
          type="number"
          id="followers"
          value={formData.followers}
          onChange={handleChange}
          placeholder="Approximate follower count"
          min="0"
          required
        />

        <label htmlFor="contentType">Content Type:</label>
        <input
          type="text"
          id="contentType"
          value={formData.contentType}
          onChange={handleChange}
          placeholder="Gaming, tutorials, reviews, etc."
          required
        />

        <label htmlFor="whyJoin">Why do you want to collaborate with RixxyMC?</label>
        <textarea
          id="whyJoin"
          rows="4"
          value={formData.whyJoin}
          onChange={handleChange}
          placeholder="Tell us why you want to work with us"
          required
        ></textarea>

        <button type="submit">Submit Application</button>
      </form>
    </div>
  );
};

export default MediaInfluencerApply;
